"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeProdViewLoadCreator = void 0;
var freeProdViewLoadCreator = function (event) {
    var _a, _b;
    var eventData = {
        action: 'free-prod-view',
        event: 'free-prod-view-load',
        eventInfo: 'free-prod-view-load',
        product: (_b = (_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.cart) === null || _b === void 0 ? void 0 : _b.product,
    };
    return eventData;
};
exports.freeProdViewLoadCreator = freeProdViewLoadCreator;
